<script>
import moment from 'moment'
import questionIcon from '@/assets/images/icons/question.svg?inline'
import closeIcon from '@/assets/images/icons/close.svg?inline'
import { capitalize } from '@/utils/helpers'

export default {
  name: 'excursion-modal-info',
  components: {
    questionIcon,
    closeIcon
  },
  props: {
    excursionData: {
      type: Object,
      default: () => {},
      required: true
    },
    excursionIndex: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    isModalActive: false,
    isLoading: true
  }),
  computed: {
    excursionDetails() {
      return this.$store.getters['cart/getExcursionDetails'](this.excursionIndex)
    },
    excursionType() {
      const { data, include } = this.excursionDetails

      return `${capitalize(include.goTypes[data.goType])}, ${include.types[data.type]}`
    },
    showModalContent() {
      const { data, include } = this.excursionDetails

      return data && include
    },
  },
  methods: {
    showModal() {
      this.$store.commit('cart/setExcursionDetailsLoading', {
        excursionIndex: this.excursionIndex,
        status: true
      })
      this.$store.dispatch('cart/getExcursionDetails', {
        excursionIndex: this.excursionIndex,
        form: this.excursionData
      })

      this.isModalActive = true
    },
    hideModal() {
      this.$store.commit('cart/setExcursionDetails', {
        excursionIndex: this.excursionIndex,
        form: {
          ...this.excursionDetails,
          data: null,
          include: null,
          hasError: false,
          errors: false
        }
      })
      this.isModalActive = false
    },
    excursionDuration(duration) {
      const hourPart = duration % 60
      let excursionDuration = null

      if (hourPart) {
        const hours = moment.duration(Math.floor(duration / 60), 'hours').humanize()
        const minutes = moment.duration(hourPart, 'minutes').humanize()

        excursionDuration = `${hours} ${minutes}`
      } else {
        excursionDuration = moment.duration(duration, 'minutes').humanize()
      }

      return excursionDuration
    }
  }
}
</script>
<template>
  <div class="cart__excursion-modal-info">
    <questionIcon
      fill="#55b7a1"
      @click="showModal"
    />
    <b-modal
      :active.sync="isModalActive"
      scroll="keep"
      :width="540"
      :can-cancel="['escape', 'outside']"
      @close="hideModal"
    >
      <div
        class="card"
      >
        <b-loading
          :is-full-page="false"
          :active="excursionDetails.isLoading"
        />
        <template
          v-if="!excursionDetails.isLoading"
        >
          <div
            v-if="excursionDetails.hasError"
          >
            <h2
              v-for="(item, index) in excursionDetails.errors"
              :key="index"
              class="cart__penalties--error"
            >
              {{ item }}
            </h2>
          </div>
          <template v-else-if="showModalContent">
            <div class="cart__excursion-modal-info-header">
              <div class="cart__excursion-modal-info-image">
                <img
                  :src="excursionDetails.data.photos[0]"
                  alt=""
                >
              </div>
              <h2 class="cart__excursion-modal-info-title">
                {{ excursionDetails.data.name }}
              </h2>
            </div>
            <div class="cart__excursion-modal-info-close">
              <close-icon
                fill="#ABABAB"
                @click="hideModal"
              />
            </div>
            <div class="cart__excursion-modal-info-content">
              <p>{{ excursionDetails.data.shortDescription }}</p>
              <p>{{ excursionDetails.data.description }}</p>
            </div>
            <div class="cart__excursion-modal-info-detail">
              <div class="cart__excursion-modal-info-detail-header">
                Тип экскурсии:
              </div>
              <div class="cart__excursion-modal-info-detail-content">
                {{ excursionType }}
              </div>
            </div>
            <div class="cart__excursion-modal-info-detail">
              <div class="cart__excursion-modal-info-detail-header">
                Место встречи:
              </div>
              <div class="cart__excursion-modal-info-detail-content">
                {{ excursionDetails.data.placeToMeet }}
              </div>
            </div>
            <div class="cart__excursion-modal-info-detail">
              <div class="cart__excursion-modal-info-detail-header">
                Продожительность:
              </div>
              <div class="cart__excursion-modal-info-detail-content">
                {{ excursionDuration(excursionDetails.data.duration) }}
              </div>
            </div>
          </template>
        </template>
      </div>
    </b-modal>
  </div>
</template>